<template>
    <v-container grid-list-md>
            <div id="printMe" class="marca">
                <!-- <h3 class="visualizado">RECIBO</h3> -->
                <table style="width:100%;">
                    <thead>
                        <tr>
                            <th align="left">CPC: {{ data.unionize.cpc }} Nombre: {{ data.unionize.user.name }}</th>
                            <th align="right">Factura Numero: {{ data.id }}</th>
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th align="left">Rif y/o Cedula: {{ data.unionize.user.nacionality }}{{ data.unionize.user.number_id }}</th>
                            <th align="right">Fecha de Emisión: {{ data.payment_date }}</th>
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th align="left"></th>
                            <th align="right">Cond. de pago: </th>
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th align="left"></th>
                            <th align="right">Cajero: {{ data.cash_assignment != null ? data.cash_assignment.cash.name : 'Caja Web' }}</th>
                        </tr>
                    </thead>
                </table>
                <table style="width:100%;">
                    <thead>
                        <tr>
                            <th align="left" style="border-top: 3px dashed; border-bottom: 3px dashed;">CODIGO</th>
                            <th align="left" style="border-top: 3px dashed; border-bottom: 3px dashed;">DESCRIPCION</th>
                            <th align="left" style="border-top: 3px dashed; border-bottom: 3px dashed;">CANTIDAD</th>
                            <th align="right" style="border-top: 3px dashed; border-bottom: 3px dashed;">COSTO UNIT.</th>
                            <th align="right" style="border-top: 3px dashed; border-bottom: 3px dashed;">TOTAL Bs.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="concepts in data.service_payments" :key="concepts.id">
                            <td align="left">{{ concepts.concept_cost.concept.code }}</td>
                            <td align="left">{{ concepts.concept_cost.concept.name }}</td>

                            <td align="left" v-if="concepts.concept_cost.concept.code != 'HSEG' && concepts.concept_cost.concept.code != 'HSEGUEL'">{{ concepts.concept_cost.concept.qty }}</td>
                            <td align="left" v-if="concepts.concept_cost.concept.code == 'HSEG'">{{ data.solicitud_papeles.cantidad }}</td>
                            <td align="left" v-if="concepts.concept_cost.concept.code == 'HSEGUEL'">{{ concepts.count }}</td>

                            <td align="right" v-if="concepts.concept_cost.concept.code == 'RAP'">{{ new Intl.NumberFormat("de-DE").format(parseFloat(concepts.ruap.concept_document_type.amount).toFixedDown(2)) }}</td>
                            <td align="right" v-if="concepts.concept_cost.concept.code == 'NCRED'">{{ new Intl.NumberFormat("de-DE").format(parseFloat(concepts.amount).toFixedDown(2)) }}</td>
                            <td align="right" v-if="concepts.concept_cost.concept.code != 'NCRED' && concepts.concept_cost.concept.code != 'RAP'">{{ new Intl.NumberFormat("de-DE").format(parseFloat(concepts.concept_cost.amount).toFixedDown(2)) }}</td>
                            
                            <td v-if="concepts.concept_cost.concept.code == 'NCRED'" align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(concepts.amount).toFixedDown(2)) }}</td>
                            <td v-if="concepts.concept_cost.concept.code == 'HSEG'" align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat((concepts.concept_cost.amount * data.solicitud_papeles.cantidad)).toFixedDown(2)) }}</td>
                            <td v-if="concepts.concept_cost.concept.code == 'HSEGUEL'" align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat((concepts.amount * concepts.count)).toFixedDown(2)) }}</td>
                            <td v-if="concepts.concept_cost.concept.code == 'RAP'" align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(concepts.ruap.concept_document_type.amount).toFixedDown(2)) }}</td>
                            <td v-if="concepts.concept_cost.concept.code != 'HSEGUEL' && concepts.concept_cost.concept.code != 'NCRED' && concepts.concept_cost.concept.code != 'HSEG' && concepts.concept_cost.concept.code != 'RAP'" align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(concepts.concept_cost.amount).toFixedDown(2)) }}</td>
                        </tr>
                        <tr v-if="monto_gg != 0">
                            <td align="left">GG</td>
                            <td align="left">CUOTA POR GESTIÓN GREMIAL</td>
                            <td align="left">1</td>
                            <td align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(monto_gg).toFixedDown(2)) }}</td>
                            <td align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(monto_gg).toFixedDown(2)) }}</td>
                        </tr>
                    </tbody>
                    <!-- //13// $2y$10$/n/EhnQZfZoJGvmonIubgeAokq6VrBX7PfTM8bq//3hntujM4zhBm -->
                    <!-- $2y$10$tLIcU8Eyfq8u.4ESZBXwlOXJk/6stgyrlhdi5ZKjZqO5iV8xFQvai -->
                    <tfoot>
                        <tr>
                            <td colspan="3" style="border-top: 3px dashed;">FORMA DE PAGO: {{ data.payments.length != 0 ? data.payments[0].way_to_pay : '' }} </td>
                            <td align="right" style="border-top: 3px dashed;">SUB-TOTAL :</td>
                            <td align="right" style="border-top: 3px dashed;">{{ new Intl.NumberFormat("de-DE").format(parseFloat(sup_total).toFixedDown(2)) }}</td>
                        </tr>
                        <tr>
                            <td colspan="3"></td>
                            <!-- <td align="right">--.-- % IVA :</td> -->
                            <td align="right">EXENTO :</td>
                            <td align="right">{{ getExento() }}</td>
                        </tr>
                        <tr>
                            <td colspan="3"></td>
                            <!-- <td align="right">--.-- % IVA :</td> -->
                            <td align="right">{{ txAmount }} % IVA :</td>
                            <td align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(monto_iva).toFixedDown(2)) }}</td>
                        </tr>
                        <tr>
                            <td colspan="3">SOLO PARA EL USO DEL CONTADOR PUBLICO</td>
                            <td align="right">TOTAL :</td>
                            <td align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(data.amount).toFixedDown(2)) }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
    </v-container>
</template>

<script>

Number.prototype.toFixedDown = function(digits) {
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        m = this.toString().match(re);
    return m ? parseFloat(m[1]) : this.valueOf();
};

export default {

    props: {
        data: {
            type: Object,
            required: true
        }
    },

    data () {
        return {
            datos: [],
            txAmount: 0,
            total: 0,
            ruap_amount: 0,
            sup_total: 0,
            sumatoria_sub_total: 0,
            monto_iva: 0,
            monto_gg: 0,
        }
    },

    mounted() {
        this.datos = this.data
        this.getIva(this.datos)
        this.supTotal(this.datos)
        this.getRuapAmount(this.datos.service_payments)
    },

    methods: {

        getExento(){
            let exento = 0;
            this.data.service_payments.forEach(concepts => {
                if (concepts.concept_cost.concept.code == 'RAP') {
                    exento = new Intl.NumberFormat("de-DE").format(parseFloat(concepts.ruap.concept_document_type.amount).toFixed(2));
                }
            });

            return exento;
        },

        getIva(datos) {
            this.sumatoria_iva = 0;
            datos.service_payments.forEach(sp => {
                if(sp.concept_cost.concept_taxes.length != 0){
                    // console.log(sp.concept_cost, 'sp.concept_cost')
                    sp.concept_cost.concept_taxes.forEach(tx => {
                        if (tx.tax.code == 'IVA') {
                            this.txAmount = parseInt(tx.tax.amount)
                            let cantidad_items = 0
                            if(sp.concept_cost.concept.code == 'HSEG'){
                                cantidad_items = datos.solicitud_papeles.cantidad
                            }else if(sp.concept_cost.concept.code == 'HSEGUEL'){
                                cantidad_items = sp.count
                            }else {
                                cantidad_items = sp.concept_cost.concept.qty
                            }
                            let cantidad = parseFloat(parseFloat(sp.concept_cost.amount) * cantidad_items)
                            this.monto_iva = (this.txAmount / 100) * cantidad
                            this.sumatoria_iva = this.sumatoria_iva + this.monto_iva
                            this.total = parseFloat(cantidad + this.monto_iva)
                        }
                    })
                }else {
                    // console.log(sp.concept_cost, 'sp.concept_cost 2')
                    if (sp.concept_cost.concept.code == 'RAP') {
                        this.txAmount = parseInt(16)//16
                        // console.log(sp.ruap, 'sp.concept_cost 2')
                        let monto = parseFloat(sp.ruap.concept_document_type.amount)//24
                        let montogg = parseFloat(sp.ruap.concept_document_type.gg_amount)//16
                        let sum_montos = montogg//80
                        this.monto_iva = (this.txAmount / 100) * sum_montos//0.16 * 80000 = 12.800
                        this.sumatoria_iva = this.sumatoria_iva + this.monto_iva// sumatoria iva + 12.800
                        this.total = parseFloat(sum_montos + this.monto_iva) + monto// 80000 + 12.800 + 320000 = 412800
                    }
                }
            });
            this.monto_iva = this.sumatoria_iva
        },

        getRuapAmount(service_payments) {
            service_payments.forEach(sp => {
                if (sp.concept_cost.concept.code == 'RAP') {
                    this.monto_gg = parseFloat(sp.ruap.concept_document_type.gg_amount)
                }
            });
        },

        supTotal(data) {
            this.sumatoria_sub_total = 0;
            data.service_payments.forEach(sp => {
                if (sp.concept_cost.concept.code == 'RAP') {
                    let monto = parseFloat(sp.ruap.concept_document_type.amount)
                    let montogg = parseFloat(sp.ruap.concept_document_type.gg_amount)
                    this.sumatoria_sub_total = parseFloat(this.sumatoria_sub_total) + (monto + montogg)
                }else if (sp.concept_cost.concept.code == 'HSEG') {
                    this.sumatoria_sub_total = parseFloat(this.sumatoria_sub_total) + (parseFloat(sp.concept_cost.amount) * parseInt(data.solicitud_papeles.cantidad))
                }else if (sp.concept_cost.concept.code == 'HSEGUEL') {
                    this.sumatoria_sub_total = parseFloat(this.sumatoria_sub_total) + (parseFloat(sp.amount) * parseInt(sp.count))
                }else {
                    this.sumatoria_sub_total = parseFloat(this.sumatoria_sub_total) + parseFloat(sp.concept_cost.amount)
                }
            });
            this.sup_total = this.sumatoria_sub_total
        }

    }

}
</script>
<style scoped>

@media print {
    @page {
        /*size: 215.9mm 139.7mm;/* afecta el tamano de la hoja */ 
        margin-top: 35mm; /* afecta el margen de la hoja */ 
    }

    .visualizado {
        display:block;
        margin-bottom: 30px;
    }
}

@media screen {
    
    .visualizado {
        display:none;
    }

    .marca:after {
        content: url('/img/newlogo.png');
        font-size: 15em;
        opacity: 0.1;
        z-index: 1;

        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 120px;
        right: 0;
        bottom: 0;
        left: 0;

        -webkit-pointer-events: none;
        -moz-pointer-events: none;
        -ms-pointer-events: none;
        -o-pointer-events: none;
        pointer-events: none;

        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
    }
}



</style>




// WEBPACK FOOTER //
// resources/assets/js/components/factura/FacturaPagoConciliacion.vue